<div class="ngx-charts-bar-horizontal">
    <ngx-gantt  #gantt (maxLevel)="3" 
                (start)="viewOptions.start?.getDate()" 
                (end)="viewOptions.end?.getDate()" 
                [groups]="groups" 
                [items]="items" 
                [viewType]="viewType" 
                [viewOptions]="viewOptions" 
                [showToolbar]="false" 
                [toolbarOptions]="toolbarOptions">
        <ngx-gantt-table>
            <ngx-gantt-column name="Time Schedule" width="250px">
                <ng-template #cell let-item="item"> {{ item.title }} </ng-template>
            </ngx-gantt-column>
        </ngx-gantt-table>    
    </ngx-gantt>
</div>